import { JsonRpcProvider, getAddress } from 'ethers';
import type { ChainId, TokenSymbol } from '@cryptopay/core';
import { getBrowserChain, tokenFor } from './chains.js';
import { decodeBalance, encodeBalanceOf } from './erc20.js';

export interface BalanceFetcherOptions {
  readonly providerFactory?: (rpcUrl: string) => { call: JsonRpcProvider['call'] };
}

export async function fetchBalance(
  chainId: ChainId,
  symbol: TokenSymbol,
  owner: string,
  options: BalanceFetcherOptions = {},
): Promise<bigint> {
  const chain = getBrowserChain(chainId);
  const token = tokenFor(chainId, symbol);
  const provider = options.providerFactory
    ? options.providerFactory(chain.rpcUrl)
    : new JsonRpcProvider(chain.rpcUrl);
  const callData = encodeBalanceOf(getAddress(owner));
  const result = await provider.call({ to: token.address, data: callData });
  return decodeBalance(result);
}
